import * as _ from 'lodash';
import { DropdownOption } from '../../definitions/formItem/ElementConfig';
var SpecialOffer = /** @class */ (function () {
    function SpecialOffer(obj, id) {
        if (id) {
            this.id = id;
        }
        if (obj.position) {
            this.position = obj.position;
        }
        console.log('obj', obj);
        this.product_id = _.get(obj, 'product.id', _.get(obj, 'product'));
        // used only for formatting to dropdown option so it can be loaded in the control instantly 
        this.product_formatted = obj.product ? new DropdownOption({
            label: _.get(obj, 'product.attributes.name'),
            value: _.get(obj, 'product.id'),
        }) : null;
    }
    Object.defineProperty(SpecialOffer.prototype, "Id", {
        get: function () {
            return this.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpecialOffer.prototype, "Position", {
        get: function () {
            return this.position;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpecialOffer.prototype, "Product", {
        get: function () {
            return this.product_id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpecialOffer.prototype, "ProductFormatted", {
        get: function () {
            return this.product_formatted;
        },
        enumerable: false,
        configurable: true
    });
    return SpecialOffer;
}());
export { SpecialOffer };
export function createSpecialOffer(obj, id) {
    return new SpecialOffer(obj, id);
}
export function createSpecialOffers(rawSpecialOffers) {
    var specialOffers = [];
    var rawSpecialOffersData = rawSpecialOffers.data;
    for (var _i = 0, rawSpecialOffersData_1 = rawSpecialOffersData; _i < rawSpecialOffersData_1.length; _i++) {
        var rawSpecialOffer = rawSpecialOffersData_1[_i];
        var specialOffer = createSpecialOffer(rawSpecialOffer.attributes, rawSpecialOffer.id);
        specialOffers.push(specialOffer);
    }
    return specialOffers;
}



//////////////////
// WEBPACK FOOTER
// ./src/classes/definitions/specialOffer/specialOffer.ts
// module id = 134
// module chunks = 0